import { render, staticRenderFns } from "./SessionDetail.vue?vue&type=template&id=1c58c7e5&scoped=true"
import script from "./SessionDetail.vue?vue&type=script&lang=js"
export * from "./SessionDetail.vue?vue&type=script&lang=js"
import style0 from "./SessionDetail.vue?vue&type=style&index=0&id=1c58c7e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c58c7e5",
  null
  
)

export default component.exports